import { styled } from '@mui/material'

export const FormContainer = styled('div')`
  display: flex;
  flex-direction: column;
`

export const ButtonsContainer = styled('div')`
  width: 100%;
  display: flex;
  gap: 8px;
`
